import styled from "styled-components"; 

export const ContainerSubirOrden = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 30px;
    .container-btn{
        display: flex;
    }
`;